import { Link } from "react-router-dom"
import Button from "../../components/ui/Button"
import Title from "../../components/ui/Title"
import '../../styles/pages/system.scss'


const Crafts = () => {
    
    return (
        <div className="page-container">
            <div className="line-container">
            <Title
                text="System"
                size="full"
            />
            <header className="system-header">
                <h1 className="system-title">
                    New crafts! Let loose with your signature moves! 
                </h1>
                <p>
                    Pull off tactical moves with your character's unique crafts or unleash your flashy S-Craft move for tons of damage! You can even pull off Combo Crafts with your teammates now!
                </p>
            </header>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        Crafts
                    </h1>
                    <p>
                        Crafts are special moves that are unique to each character. They can have a wide range of possible effects, from a powerful ranged attack, to healing, to enhancing your team's attributes. As your characters level up, they'll add even more powerful crafts to their arsenal.
                        <br/>
                        Using crafts consumes CP (Craft Points). Unlike EP, which can be replenished by resting, CP can only be accumulated by dealing damage and taking attacks from enemies in battle.
                    </p>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Randy - Power Smash</h1>
                        <p>
                            A powerful swing of the stun halberd damages enemies and delays their attack turn order.
                        </p>
                    </div>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Tio - Analyze</h1>
                        <p>
                            Scans the enemy's weak points, unlocking information on them and reducing their defenses.
                        </p>
                    </div>
                </div>
            </div>
            <div className="system-pair">
                <div className="system-info">
                    <h1 className="system-info_title">
                        S-Crafts
                    </h1>
                    <p>
                        Extremely powerful skills unique to each character that consume all their CP to use. A character must have at least 100 CP to activate their S-Craft, but if they use it when their CP is at max, it will boost the skill's power even further!
                    </p>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Lloyd - Tiger Charge</h1>
                        <p>
                            Overwhelms a foe with a barrage of attacks, then pounces like a tiger for the final blow, dealing heavy damage and inflicting seal.
                        </p>
                    </div>
                </div>
                <div className="vertical-pair">
                    <div className="vertical-info">
                        <h1>Elie - Aura Rain</h1>
                        <p>
                            Conjures a healing rain to restore allies' HP. If used when Elie's CP is at max, it will restore their HP to full.
                        </p>
                    </div>
                    <div className="system-info_image">
                        <img src={`${process.env.PUBLIC_URL}/img/ss/elie-craft.webp`} alt="" />
                    </div>
                </div>
            </div>
            <div className="system-pair" style={{paddingBottom: '25px'}}>
                <div className="system-info">
                    <h1 className="system-info_title">
                        Combo Crafts
                    </h1>
                    <p>
                        A new type of craft, Combo Crafts let you spend 100 CP to work together with another party member and unleash a potent team-up ability.
                        <br/>
                        As you progress through the game, certain events will unlock additional Combo Crafts to add to your arsenal!
                    </p>
                    <h1 className="system-info_title">
                        Support Crafts
                    </h1>
                    <p>
                        When you have more than four members in your party, characters on standby will automatically assist your combat members during battle. Standby characters will appear in the AT bar on the left side of the screen, and when their turn is up, they'll pop in to attack foes or help the team out with a support ability.
                    </p>
                </div>
            </div>
            <Link to="/system">
                <Button
                    text="Go Back"
                    type="solid"
                />
            </Link>
            </div>
        </div>
    )
}

export default Crafts